// @ts-nocheck
import {
  chakra,
  Box,
  Flex,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useFormState } from 'react-final-form';
import IntakeConfig from '../../../interfaces/IntakeConfig.interface';
import formatPrice from '../../../services/formatPrice';
import getAddonList from '../../../services/getAddonList';

const getInitialCoupons = (config: IntakeConfig) => {
  if (!config.coupons) return [];
  if (Array.isArray(config.coupons)) return config.coupons;
  try {
    if (typeof config.coupons === 'function') return config.coupons();
  } catch (error) {
    console.error('Error getting initial coupons', { cause: error });
  }
  return [];
};

const Summary = ({ config }: { config: IntakeConfig }) => {
  const formState = useFormState();
  const plan = config.plan.countries[formState.values.address.country];
  const planPeriod = plan.periods.find(p => p.id === formState.values.plan);
  const addons = getAddonList(config, formState.values);
  const coupons = getInitialCoupons(config);

  return (
    <Flex direction="column" gap="1em" width="100%">
      <Heading size="md">Summary</Heading>
      <VStack divider={<chakra.hr borderColor="gray.300" />} align="stretch" gap="1em" my="2em">
        <div />
        {planPeriod && <SummaryItem label={plan.label} unit={planPeriod.unit} price={planPeriod.price} />}
        {
          coupons.length
            ? coupons.map((code: string) => <CouponItem code={code} key={code} />)
            : null
        }
        {
          addons.map((addon) => (
            <SummaryItem label={addon.label} price={addon.price} unit={addon.unit} key={addon.id} />
          ))
        }
        <div />
      </VStack>
      <Sum addons={addons} plan={planPeriod} />
    </Flex>
  );
};

const CouponItem = ({ code }: { code: string }) => (
  <Box>
    <Flex direction="row" gap="1em">
      <Heading size="sm" w="100%">Coupon</Heading>
      <Text as="code">{code}</Text>
    </Flex>
    <Text size="small" color="gray.500">Applied at checkout</Text>
  </Box>
);

const SummaryItem = ({ label, price, unit }: {
  label: string,
  price: number,
  unit: string,
}) => {
  const formattedPrice = formatPrice(price);
  return (
    <Flex direction="row" gap="1em">
      <Box w="100%">
        <Heading size="sm">{label}</Heading>
        <Text color="gray.500">{unit}</Text>
      </Box>
      <Text as="b">{formattedPrice}</Text>
    </Flex>
  );
};

const Sum = ({ addons, plan }: {
  addons: any[],
  plan?: IntakeConfig['plan']['countries'][string]['periods'][number],
}) => {
  let oneTimePrice = plan?.price || 0;
  addons.forEach((addon) => {
    oneTimePrice += addon.price;
  });
  return (
    <Flex direction="row" gap="1em" divider={<hr />}>
      <Box w="100%">
        <Heading size="sm">Due Today</Heading>
      </Box>
      <Flex direction="column" align="flex-end">
        <Heading size="sm">{formatPrice(oneTimePrice)}</Heading>
        {plan && (
          <Text color="gray.500" whiteSpace="nowrap">Plus tax</Text>
        )}
      </Flex>
    </Flex>
  );
};

export default Summary;
